import styles from 'styles/AnimateScreen.module.css'
import wickIcon from 'assets/images/common/wickIcon.gif'
import wickBackground from 'assets/images/common/wickBackground.gif'


function AnimateScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        Let's Animate
      </div>
      <div className={styles.imagesContainer}>
        <img
          src={wickIcon}
          alt='wick'
          className={styles.image}
        />
      </div>
      <div className={styles.button} onClick={()=>window.open('https://www.wickeditor.com/editor/')}>
        WICK EDITOR
      </div>
    </div>
  )
}

export default AnimateScreen
